import { render, staticRenderFns } from "./Helpdesk.vue?vue&type=template&id=362d49c9&scoped=true"
import script from "./Helpdesk.vue?vue&type=script&lang=ts"
export * from "./Helpdesk.vue?vue&type=script&lang=ts"
import style0 from "./Helpdesk.vue?vue&type=style&index=0&id=362d49c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362d49c9",
  null
  
)

export default component.exports